import { render, staticRenderFns } from "./TemplateButtons.vue?vue&type=template&id=2e21381c&scoped=true&"
import script from "./TemplateButtons.vue?vue&type=script&lang=ts&"
export * from "./TemplateButtons.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateButtons.vue?vue&type=style&index=0&id=2e21381c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e21381c",
  null
  
)

export default component.exports